import { useSelector } from "react-redux";
import { useMatch } from "react-router-dom";
import { individualSelectors } from "../redux/individual/selectors";
import { lawyerSelectors } from "../redux/lawyer/selectors";
import { RootState } from "../redux/store";

// Custom hook to encapsulate all role and subscription checks
export const useUserRoleAndSubscription = () => {
  // Extract the necessary data from Redux store using useSelector
  const hideQualityReview = useSelector(
    lawyerSelectors.selectHideQualityReview
  );
  const {
    subscription,
    role,
    practiceName: lawyerPractice,
    uid: lawyerId,
    email
  } = useSelector(lawyerSelectors.selectAll);
  const indivId = useSelector((state: RootState) =>
    individualSelectors.selectUid(state)
  );

  // Determine user role and subscription status
  const isSuperAdmin = role === "superadmin";
  const isAdminDashboard =
    isSuperAdmin && window.location.pathname.includes("/admin/");
  const isFullUser = role === "full";
  const isStandardUser = role === "standard";
  const isPaidUser = subscription?.status === "paid";
  const isFreeTrialUser = subscription?.status === "free_trial";
  const isIndividual = indivId ?? false;
  const shouldHideQualityReview = hideQualityReview ?? false;

  // Return all boolean values for use in components
  return {
    isIndividual,
    isSuperAdmin,
    isAdminDashboard,
    isFullUser,
    isStandardUser,
    isFreeTrialUser,
    isPaidUser,
    shouldHideQualityReview,
    role,
    lawyerId,
    lawyerPractice,
    email
  };
};
